<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">

      <el-form-item label="退库单号:" v-if="form.number">
        {{form.number}}
      </el-form-item>

      <el-form-item label="所属仓库:">
        <!-- {{from.outHouse.name}} -->
        <router-link class="link" target="_blank" :to="'/Storage/Detail/'+form.house.id">
          {{form.house.name}}
        </router-link>
      </el-form-item>
      <el-form-item label="客户名称:" v-if="form.customer">
        {{form.customer}}
      </el-form-item>
      <el-form-item label="所属工程:" v-if="form.projectName">
        <router-link class="link" target="_blank" :to="'/Project/Detail/'+form.projectId">
          {{form.projectName}}
        </router-link>
      </el-form-item>
      <el-form-item label="退库申请人:">
        <user-info :userData='form.creator'></user-info>
      </el-form-item>
      <el-form-item label="退库时间:">
        {{ getTime(form.time) }}
      </el-form-item>
      <!-- <el-form-item label="总金额(元):">
        {{total}}
      </el-form-item> -->
      <el-form-item class="full" label="材料明细:">
        <div class="material-table">
          <el-table :summary-method="getSummaries" show-summary :data="form.materials" border>
            <el-table-column prop="number" label="材料编号">
            </el-table-column>
            <el-table-column prop="name" label="明细名称" width="240">
            </el-table-column>
            <el-table-column prop="dlName" label="材料类别" width="200">
            </el-table-column>
            <el-table-column prop="unitName" align="center" label="计量单位">
            </el-table-column>

            <el-table-column prop="" align="center" label="数量">
              <template slot-scope="scope">
                {{ scope.row.amount && parseFloat(scope.row.amount).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="单价(元)" v-if="form.number">
              <template slot-scope="scope">
                {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
              </template>
            </el-table-column>

            <el-table-column prop="totalPrice" align="center" label="总价(元)" v-if="form.number">
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      total: function () {
        var _total = 0
        for (var i = 0; i < this.form.materials.length; i++) {
          var _item = this.form.materials[i]
          _total += _item.totalPrice / 1
        }
        return _total
      }
    },
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(t) {
        return util.getFormatDate(t, true)
      },
      // 合计
      getSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        console.log(columns)
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return
          }
          if (index === 4 && this.form.number) {
            return
          }

          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = sums[index].toFixed(2)
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/storage/components/materialBackDetail.vue